module.exports = __webpack_public_path__ + "img/rawMaterials.dfbf317a.png";